import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../utils/colors';

const PageLayout = styled(Box)({
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  backgroundColor: spaceCadet[100],

  '& > .MuiBox-root.header': {
    padding: '8px 24px 8px',
    backgroundColor: 'white',
    '& .title': {
      display: 'flex',
      gap: 8,
      '& .MuiButtonBase-root.nav-previous': {
        minWidth: 0,
        padding: 0,
        color: spaceCadet[800],
        fontSize: 28,
        '& svg': {
          fontSize: 'inherit',
          color: 'inherit',
        },
        '&:hover': {
          backgroundColor: spaceCadet[100],
        },
      },
      '& .MuiTypography-h1': {
        fontSize: 24,
        fontWeight: 700,
      },
      '& .flexGrow': {
        flexGrow: 1,
      },
    },

    '& .MuiTabs-root': {
      '& .MuiTab-root': {
        '&.Mui-selected': {
          fontWeight: 700,
        },
        color: spaceCadet[800],
      },
      '& .MuiTabs-indicator': {
        height: 3,
        width: '65%',
      },
    },
  },
});

export default PageLayout;
